import component from './newsletter.component';
import item from './item/item.component';

export default angular.module('mpdx.tools.fix.sendNewsletter', [component, item]).name;
